(function () {
  function hashText(value) {
    var hash = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      hash ^= value.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function formatCssString(value) {
    return '"' + String(value) + '"';
  }

  function getFallbackLikeCount(value) {
    return (hashText(value) % 9701) + 300;
  }

  function extractLikeCount(html) {
    var match = html.match(/--note-like-count:\s*['"]?(\d+)['"]?/);
    return match ? match[1] : "";
  }

  function sameOriginUrl(href) {
    try {
      var url = new URL(href, window.location.href);
      return url.origin === window.location.origin ? url : null;
    } catch (error) {
      return null;
    }
  }

  function setRelatedLikeCount(item, value) {
    item.style.setProperty("--note-related-like-count", formatCssString(value));
  }

  function requestText(url, callback) {
    if (typeof window.fetch === "function") {
      window
        .fetch(url, { credentials: "same-origin" })
        .then(function (response) {
          return response.ok ? response.text() : "";
        })
        .then(callback)
        .catch(function () {});
      return;
    }

    var request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.onreadystatechange = function () {
      if (request.readyState !== 4) return;
      callback(request.status >= 200 && request.status < 300 ? request.responseText : "");
    };
    request.send();
  }

  function applyRelatedLikeCounts() {
    var items = document.querySelectorAll(
      "body.template-article .left_sideitem .side_post_item li"
    );

    items.forEach(function (item) {
      var link = item.querySelector(".item_title a");
      var seed = link ? link.getAttribute("href") || link.textContent || "" : "";
      var url = link ? sameOriginUrl(link.getAttribute("href")) : null;
      setRelatedLikeCount(item, getFallbackLikeCount(seed));

      if (!url) return;

      requestText(url.href, function (html) {
        var count = extractLikeCount(html);
        if (count) setRelatedLikeCount(item, count);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyRelatedLikeCounts);
  } else {
    applyRelatedLikeCounts();
  }
})();
